__turbopack_context__.v({
  "item-render-subtitle": "Fn9m8q_item-render-subtitle",
  "item-subtitle": "Fn9m8q_item-subtitle",
  "list-item": "Fn9m8q_list-item",
  "section-image": "Fn9m8q_section-image",
  "section-items": "Fn9m8q_section-items",
});
